import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivCreateProductDtoGen,
  MrfiktivProductControllerGetParamsGen,
  MrfiktivUpdateProductDtoGen
} from "../v1/data-contracts";
import { Products } from "../v1/Products";

/**
 * Communicate with product API
 */
class ProductService {
  mrfiktivProxy: Products;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new Products(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create
   */
  async create(partnerId: string, data: MrfiktivCreateProductDtoGen) {
    const response = (await this.mrfiktivProxy.productControllerCreate(partnerId, data)).data;

    return response;
  }

  /**
   * Get all products
   */
  async get(data: MrfiktivProductControllerGetParamsGen) {
    const response = (await this.mrfiktivProxy.productControllerGet(data)).data;

    return response;
  }

  /**
   * Get a product
   */
  async getOne(partnerId: string, productId: string) {
    const response = (await this.mrfiktivProxy.productControllerGetById(partnerId, productId)).data;

    return response;
  }

  /**
   * Update a product
   */
  async update(partnerId: string, productId: string, data: MrfiktivUpdateProductDtoGen) {
    const response = (await this.mrfiktivProxy.productControllerUpdate(partnerId, productId, data)).data;

    return response;
  }

  /**
   * Delete a product
   */
  async delete(partnerId: string, productId: string) {
    const response = (await this.mrfiktivProxy.productControllerDeleteByProductId(partnerId, productId)).data;

    return response;
  }
}

/**
 * Communicate with product API
 */
export default new ProductService(new MrfiktivHttpClientProvider());
